<template>
  <div :class="iframe_popup_class" @click.prevent="click_close_popup">
    <!--      <div  v-if="show_instructions" class="dummy text-md py-2 mt-8 mb-auto inline-block">&nbsp;</div>-->
    <div class="popup_iframe_container relative">
      <div class="option-bar" @click.prevent="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <div class="scroll-helper">
        <iframe :src="src" :style="img_style" />
        <div
          class="ml-auto pt-5"
          v-if="getCurrentSectionContent().show_download"
          @click="prevent_close"
        >
          <a
            :href="get_item_href()"
            v-ga="
              $ga.commands.trackExternalLink.bind(get_this, get_item_href())
            "
            target="_blank"
            class="uppercase bg-red-500 text-white inline-block px-4 py-2 rounded shadow-md"
            @click="show_external_content()"
            >download</a
          >
        </div>
      </div>
    </div>
    <!--      <div v-if="show_instructions" class="app-popup-instructions text-gray-100 text-sm px-12 py-2 text-md w-18 rounded-full inline-block mb-8 bg-black self-center mt-auto">-->
    <!--        <span>The image will close automatically after a few seconds.</span>-->
    <!--      </div>-->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ImagePopup",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "sections_content",
      "current_secondary_section",
      "current_secondary_sub_section"
    ]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"]),
    page_url() {
      var str =
        "/" +
        this.eventTag +
        "/" +
        this.selected_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-")
          .toLowerCase() +
        "/" +
        this.selected_sub_section_name
          .split(" ")
          .join("-")
          .split("/")
          .join("-") +
        "/iframe";

      return str;
    },
    img_style() {
      let style = {};

      if ("undefined" != typeof this.getCurrentSectionContent().style) {
        style = this.getCurrentSectionContent().style;
      }
      return style;
    },
    src() {
      return this.getCurrentSectionContent().src;
    },
    iframe_popup_class() {
      return "popup " + this.loading;
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    },

    selected_section_name() {
      if (this.current_secondary_section != "") {
        if (this.current_secondary_section == "0") {
          return "home";
        }
        return this.current_secondary_section;
      }

      if (this.current_section === 0) {
        return "home";
      }
      return this.getSection(this.current_section).name;
    },
    selected_sub_section_name() {
      return this.selected_sub_section;
    },

    get_this() {
      return this;
    }
  },
  methods: {
    getCurrentSectionContent() {
      return this.sectionContent(this.selected_section).subids[
        this.selected_sub_section
      ];
    },
    get_item_href() {
      if (this.getCurrentSectionContent().show_download) {
        return (
          "static/content/" +
          this.selected_section +
          "/" +
          this.selected_sub_section +
          "/pdf/" +
          this.getCurrentSectionContent().filename
        );
      }
    },
    click_close_popup(e) {
      e.preventDefault();
      this.close_popup(e);
    },
    close_popup(e) {
      console.log("close popup");
      //if(e)
      //e.preventDefault();

      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_img_src, 10)
        );
      }

      this.$bus.$emit("send_interactive_msg", "popupClosed", 1);
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },

    show_external_content() {
      this.$ga.page(
        this.page_url +
          "/content/1" +
          "/external_link/?file=" +
          this.getCurrentSectionContent().filename
      );
    }
  },
  mounted() {
    this.$bus.$on("on-request-video-close", this.close_popup);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
}
iframe {
  max-width: 1100px;
  overflow: hidden;
}
.option-bar {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
.popup_iframe_container {
  align-self: center;
  margin: 0 0;
}
.popup_iframe_container iframe {
  max-height: 1940px;
  width: 95vw;
  height: 90vh;
  margin-top: 0;
  object-fit: contain;
}
.scroll-helper {
  max-height: 90vh;
  overflow-y: none;
  background: #fff;
}
@media only screen and (max-width: 1110px) {
  .popup .vueperslides__arrows--outside {
    display: none;
  }
  .popup .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
@media only screen and (max-width: 800px) and (max-height: 820px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/IframePopup.vue